import { IconDots, IconDownload, IconPlus } from '@tabler/icons-react';
import { BenefitType } from '@zorro/clients';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Menu } from '@zorro/design-system/v2/Menu';
import { Group } from '@zorro/web/design-system';
import { getBenefitTypeLabel, useMonolithQuery } from '@zorro/web/ui-utils';
import { useState } from 'react';

import { HeaderWithIcon } from '../../../../../HeaderWithIcon';
import { getEmployeePagePlansBenefitHeaderConfig } from './EmployeePagePlansBenefitHeaderUtils';

type Props = {
  onboardingPeriodId: string;
  benefitType: BenefitType;
  onAddPlanClick?: () => void;
};

export const EmployeePagePlansBenefitHeader = ({
  onboardingPeriodId,
  onAddPlanClick,
  benefitType,
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const { data: onboardingPeriod } = useMonolithQuery({
    method: 'onboardingPeriodReportsControllerGenerateOnboardingPeriodReport',
    params: [onboardingPeriodId],
  });

  const headerConfig = getEmployeePagePlansBenefitHeaderConfig(benefitType);
  if (!headerConfig || !onboardingPeriod) {
    return null;
  }

  const label = getBenefitTypeLabel(benefitType);
  const { icon, title, onDownload } = headerConfig;
  const { isActive } = onboardingPeriod;

  return (
    <Group justify="space-between">
      <HeaderWithIcon icon={icon} title={title} />
      <Menu opened={open} onChange={setOpen} size="md" position="bottom">
        <Menu.Target>
          <ActionIcon
            bd="1px solid var(--color-border-default-primary)"
            isChecked={open}
          >
            <IconDots color="var(--color-icon-fill-on-secondary)" />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {onAddPlanClick && isActive && (
            <Menu.Item
              onClick={onAddPlanClick}
              leftSection={<IconPlus size={16} stroke={1.25} />}
            >
              Add a {label} plan
            </Menu.Item>
          )}
          <Menu.Item
            onClick={() => onDownload({ onboardingPeriod })}
            leftSection={<IconDownload size={16} stroke={1.25} />}
          >
            Download all {label} plans
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
